module.exports = __webpack_public_path__ + "static/img/pint.e5d898f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/pint.png
// module id = hqq6
// module chunks = 0